import { create } from "zustand";

// Limits on the return in progress that the till's posConfig doesn't carry.
// refundBlocked: the bill being returned was paid to the online store, so the
// till mustn't pay it back (Fashion: online orders go to store credit or an
// exchange). Kept in memory only: it belongs to the return on screen, and a
// reload starts the return again.
const useReturnPolicyStore = create((set) => ({
  refundBlocked: false,
  setRefundBlocked: (refundBlocked) => set({ refundBlocked: Boolean(refundBlocked) }),
}));

export default useReturnPolicyStore;
